import { ArrowUpRight } from "lucide-react";
import CoffeeSequence from "../components/CoffeeSequence";

const products = [
  {
    id: "cafes",
    tag: "Cafés especiais",
    title: "Do tradicional ao Café do Jacu",
    body: "Tradicional, Gourmet ou Especial — moídos na hora para preservar cada nota aromática. Experimente o Café do Jacu, um dos mais raros e disputados do mundo, e entenda por que dizem que o melhor café do mundo está aqui.",
    image:
      "https://images.unsplash.com/photo-1511920170033-f8396924c348?auto=format&fit=crop&w=1400&q=80",
    meta: "50+ rótulos",
  },
  {
    id: "queijos",
    tag: "Queijos artesanais",
    title: "Canastra legítimo, de produtor que a gente conhece",
    body: "Queijo canastra legítimo, vindo direto da Serra da Canastra, Cruzília e Alagoa. Servido em fatias generosas no pão de queijo recheado — ou inteiro, para levar para casa. Porque Minas sem queijo não é Minas.",
    image:
      "https://images.unsplash.com/photo-1486297678162-eb2a19b0a32d?auto=format&fit=crop&w=1400&q=80",
    meta: "3 terroirs",
  },
  {
    id: "cachacas",
    tag: "Cachaças & destilados",
    title: "A primeira aguardente de café do Brasil",
    body: "Uma curadoria de cachaças premiadas, incluindo a pioneira aguardente de café do Brasil. Rótulos que venceram a ExpoCachaça e que você dificilmente encontra em outro lugar.",
    image: "/cachaca.avif",
    meta: "Campeã ExpoCachaça",
  },
  {
    id: "doces",
    tag: "Geleias, doces & presentes",
    title: "Sabores de Minas para levar de lembrança",
    body: "Geleias artesanais — doces, sem açúcar e apimentadas. Doces de leite dos melhores produtores do país. E kits montados com carinho para presentear — ou se presentear, sem culpa.",
    image: "/doces.avif",
    meta: "Kits mineiros",
  },
];

export default function Products() {
  return (
    <section
      id="produtos"
      data-testid="products-section"
      className="relative bg-cream py-24 md:py-36 overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-6 md:gap-10 items-end mb-14 md:mb-20">
          <div className="md:col-span-8 reveal-left">
            <div className="eyebrow text-gold mb-5 reveal-eyebrow">Nossos produtos</div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-[80px] leading-[1.02] tracking-[-0.02em] text-espresso max-w-[20ch] reveal-clip">
              Do grão ao gole, <em className="italic text-gold">Minas inteira em um balcão.</em>
            </h2>
          </div>
          <div className="md:col-span-4 reveal-right">
            <p className="text-espresso/70 text-base md:text-[17px] leading-relaxed">
              Quatro categorias, uma filosofia: origem rastreada, produtores
              parceiros e sabor que conta história.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-stagger-group>
          {products.map((p, i) => (
            <article
              key={p.id}
              data-stagger-item
              data-testid={`product-card-${p.id}`}
              className={`product-card group relative rounded-[14px] overflow-hidden border border-espresso/10 bg-cream-50 ${
                i === 0 || i === products.length - 1 ? "md:col-span-2" : ""
              }`}
            >
              <div
                className={`grid ${i === 0 || i === products.length - 1 ? "md:grid-cols-[1.1fr_1fr]" : "grid-cols-1"}`}
              >
                <div
                  className={`relative overflow-hidden ${i === 0 || i === products.length - 1 ? "h-[360px] md:h-[440px]" : "h-[300px]"}`}
                >
                  {p.id === "cafes" ? (
                    <CoffeeSequence className="product-img absolute inset-0 w-full h-full" />
                  ) : (
                    <img
                      src={p.image}
                      alt={p.title}
                      className="product-img absolute inset-0 w-full h-full object-cover"
                      loading="lazy"
                    />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-espresso/60 via-transparent to-transparent" />
                  <div className="absolute top-5 left-5 font-mono text-[10px] tracking-[0.28em] uppercase text-cream bg-espresso/60 backdrop-blur px-3 py-1.5 rounded-full border border-cream/15">
                    {p.meta}
                  </div>
                </div>
                <div className="p-7 md:p-10 flex flex-col justify-between">
                  <div>
                    <div className="eyebrow text-gold mb-5">{p.tag}</div>
                    <h3 className="font-display text-3xl md:text-[40px] leading-[1.05] tracking-[-0.02em] text-espresso max-w-[22ch]">
                      {p.title}
                    </h3>
                    <p className="mt-5 text-espresso/70 text-[15px] md:text-base leading-relaxed max-w-[52ch]">
                      {p.body}
                    </p>
                  </div>
                  <a
                    href="https://wa.me/5535999516948"
                    target="_blank"
                    rel="noreferrer"
                    className="mt-8 inline-flex items-center gap-2 font-body text-sm tracking-wide text-espresso group/link"
                    data-testid={`product-cta-${p.id}`}
                  >
                    <span className="border-b border-espresso/40 group-hover/link:border-gold pb-0.5 transition-colors">
                      Pedir no WhatsApp
                    </span>
                    <ArrowUpRight
                      size={16}
                      className="transition-transform duration-500 group-hover/link:translate-x-1 group-hover/link:-translate-y-1 text-gold"
                    />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
